
<template>
    <div>
       <Personal class="q-pa-md"/> 
       <!-- <PersonalMobile class="q-pa-md mobile-only"/>  -->
       <Contact class="q-pa-md"/>
       <!-- <ContactMobile class="q-pa-md mobile-only"/> -->
       <Address class="q-pa-md"/>
       <!-- <AddressMobile class="q-pa-md mobile-only"/> -->
       <Employment class="q-pa-md"/>
       <!-- <EmploymentMobile class="q-pa-md mobile-only"/> -->
       <FATCA class="q-pa-md"/>
       <!-- <FATCAMobile class="q-pa-md mobile-only"/> -->

       <DeclarationCheckbox 
        ref="DCB"
        class="q-pa-md"
        @Agreed="AgreeOnDeclaration()"
       />

    </div>
</template>

<script>
import { mapActions } from 'vuex';
import store from '../store'
import Personal from '@/components/SummaryPersonalInformation'
import PersonalMobile from '@/components/SummaryPersonalInformationMobile'

import Contact from '@/components/SummaryContactInformation'
import ContactMobile from '@/components/SummaryContactInformationMobile'

import Employment from '@/components/SummaryEmploymentInformation'
import EmploymentMobile from '@/components/SummaryEmploymentInformationMobile'


import Address from '@/components/SummaryAddressInformation'
import AddressMobile from '@/components/SummaryAddressInformationMobile'

import FATCA from '@/components/SummaryFATCAInformation'
import FATCAMobile from '@/components/SummaryFATCAInformationMobile'

import Navigation from '@/components/NavigationButtons'
import Declaration from '@/components/Declaration'

import DeclarationCheckbox from '@/components/DeclarationCheckbox'

export default {
    name : 'SummaryInformation',
    components : {
        Personal,
        PersonalMobile,
        Contact,
        ContactMobile,
        Employment,
        EmploymentMobile,
        Address,
        AddressMobile,
        FATCA,
        FATCAMobile,
        Navigation,
        Declaration,
        DeclarationCheckbox
    },
    data() {
        return {
            StoreStateCD : store.state.CD,
            StoreStateED : store.state.ED,
            StoreStateAOD : store.state.AOD,
             tempMobileNo:''

        }
    },
    // beforeMount(){
    //     this.scrollToTop();
    // },
    computed: {},
    methods: {
        ...mapActions([
            "GetOnboardingSelf",
            "GetLookup",
            //"GeteMisLookup",
            "RequestTAC"
        ]),
        scrollToTop() {
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        },
        AgreeOnDeclaration(){
            if(this.$refs.DCB.Agree === true){
                this.$emit('AgreeOnDeclaration')
            }
            else{
                this.$emit('DisagreeOnDeclaration')
            }
        },
        AccountConfirmation(){
            this.formatMobileNo();
            var tempval = ''
              this.$q.dialog({
                    title : 'Message',
                    message : 'A TAC has been sent to your mobile no ' + this.tempMobileNo
                })
            /*   if(this.StoreStateAOD.PersonalInformation.NRIC!=''){
                tempval = this.StoreStateAOD.PersonalInformation.NRIC;
            }else if(this.StoreStateAOD.PersonalInformation.OldID!=''){
                tempval = this.StoreStateAOD.PersonalInformation.OldID;
            }
            this.RequestTAC({
                CustomerTelMobile : this.StoreStateAOD.ContactInformation.MobileNo,
                Purpose : 'EMIS - Account Verification',
                CustomerId : tempval,
                RIDType : ''
            })
            .then(res=>{
                if(res===true){
                    this.$q.dialog({
                        title : 'Message',
                        message : 'A TAC has been sent to your mobile no ' + this.tempMobileNo
                    })
                }
            }) */
        } ,
        formatMobileNo:function() {

        var mobileNo = this.StoreStateAOD.ContactInformation.MobileNo       
        this.tempMobileNo =  '01x- xxxx ' + mobileNo.slice(-4) ;
      }
      
    },
    mounted(){
        
      /*  this.GetLookup()
        .then(res=>{
            if(this.StoreStateCD.FormDetails.ApplicationId != ""){
                 this.GetOnboardingSelf({
                
                //ApplicationId : this.$route.query.ApplicationId
               // ApplicationId : '950617105574-01-20191118165916'
               //ApplicationId:this.StoreStateCD.FormDetails.ApplicationId
               
                })
                .then(res=>{
                    this.$q.loading.hide()
                })
            }else{
                this.$q.loading.hide()
            }

            
           
            //this.$q.loading.hide()
        })*/
    }
}
</script>